export default "__VITE_ASSET__7b03efb6__"